module.exports = __webpack_public_path__ + "img/SCC_Fibroblasts.432e2c14.png";